/**
 * Serializza in modo leggibile un errore generico o un errore Supabase/PostgREST.
 *
 * Gli errori PostgREST sono oggetti con forma `{ message, code, details, hint }`
 * che, concatenati in una template string, producono `[object Object]`,
 * nascondendo la causa reale del fallimento. Questo helper estrae i campi utili
 * così che log e `errorDetail` siano diagnosticabili.
 */
export function serializeError(error: unknown): string {
  if (error == null) {
    return 'Unknown error';
  }

  if (typeof error === 'string') {
    return error;
  }

  if (typeof error === 'object') {
    const e = error as {
      message?: unknown;
      code?: unknown;
      details?: unknown;
      hint?: unknown;
    };

    const parts: string[] = [];
    if (e.message) parts.push(String(e.message));
    if (e.code) parts.push(`code=${String(e.code)}`);
    if (e.details) parts.push(`details=${String(e.details)}`);
    if (e.hint) parts.push(`hint=${String(e.hint)}`);

    if (parts.length > 0) {
      return parts.join(' | ');
    }

    try {
      const json = JSON.stringify(error);
      if (json && json !== '{}') {
        return json;
      }
    } catch {
      // ignora errori di serializzazione (riferimenti circolari, ecc.)
    }
  }

  return String(error);
}
